import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=22aed3f3"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=22aed3f3&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22aed3f3')) {
      api.createRecord('22aed3f3', component.options)
    } else {
      api.reload('22aed3f3', component.options)
    }
    module.hot.accept("./DetailList.vue?vue&type=template&id=22aed3f3", function () {
      api.rerender('22aed3f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/DetailList.vue"
export default component.exports